// The general "In-app feedback" form: what "Give feedback" opens on any page that hasn't
// chosen its own form with usePageFeedbackForm.
export const GENERAL_FEEDBACK_FORM_ID = "rXRdXDAr"

export const SUBSCRIBERS_PAGE_FEEDBACK_FORM_ID = "L1C7L2Gz"

export const CLASSIC_LANDING_PAGE_FEEDBACK_FORM_ID = "eNmrC3NA"
